<template>
  <tr>
    <td><p data-toggle="tooltip" data-placement="top" :title="rulesSet.template.description" class="text-left">{{ rulesSet.template.name }}</p></td>
    <td><p data-toggle="tooltip" data-placement="top" title="Si se pueden aplicar varias reglas en el SCR, se elegirá la que tenga más prioridad" class="text-left">{{ rulesSet.priority }}</p></td>
    <td>
      <p v-for="rule in rulesSet.rules" class="text-left">{{ rule }}</p>
    </td>
    <td><p class="text-left">{{ rulesSet.description }}</p></td>
    <td class="text-center">
      <span v-if="rulesSet.enabled === '1'" >Si</span>
      <span v-else >No</span>
    </td>
    <td>
      <router-link :to="editUrl">
        <span data-toggle="tooltip" data-placement="top" title="Editar reglas"><img src="../assets/pencil.svg" alt="Modificar reglas"></span>
      </router-link>
    </td>
    <td class="text-center">
      <span data-toggle="tooltip" data-placement="top" title="Eliminar reglas" @click="confirmRulesSet(rulesSet.id)"><img src="../assets/trashcan.svg" alt="Eliminar reglas"></span>
    </td>
  </tr>
</template>

<script>
import axios from 'axios';
import bootbox from 'bootbox';

export default {
    name: 'rules-set-table-row',
    props: ['rulesSet'],
    computed : {
        editUrl: function () {
            return "/editRulesSet/" + this.rulesSet.id;
        }
    },
    methods : {
        confirmRulesSet (ruleId) {
            let that = this;
            bootbox.confirm("Confirmar el borrado de las reglas?", function(result){
                if (result) {
                  that.deleteRulesSet (ruleId);
                }
            })
        },
        deleteRulesSet (ruleId) {
            axios
                .delete('https://res.hotelkey.com/reservas/mvc.php/product_decision_scr_templates_api_rest/RulesSet/index', { data: {id : ruleId} })
                .then(response => {
                    if (response.data.result) {
                      this.emitSuccess();
                    } else {
                      this.emitError();
                    }
                }).catch(error => {
                    this.emitError();
                })
        },
        emitError () {
            this.$emit('error', "Se ha producido un error al eliminar las reglas.");
        },
        emitSuccess () {
            this.$emit('success', "Se han eliminado las reglas correctamente.");
        }
    }
}
</script>
